{
  "dirty": false,
  "raw": "7cff44b",
  "hash": "7cff44b",
  "distance": null,
  "tag": null,
  "semver": null,
  "suffix": "7cff44b",
  "semverString": null
}